<script setup lang="ts">
import type { UIColor } from "@align/ui";

defineProps({
  color: {
    type: String as PropType<UIColor>,
    required: true,
  },

  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{ (event: "click"): void }>();
</script>

<template>
  <PushButton size="collapsed" color="--color-transparent" underline @click="() => emit('click')">
    <template #copy>
      <Copy type="bodyStrong" size="small" :color="color">
        {{ label }}
      </Copy>
    </template>
  </PushButton>
</template>
